import {
  INewScheduleFilterUser,
  IScheduleFilterUser,
} from "../models/schedule-filter-user";
import { GlobalAxios } from "./../axios/axios-config";

const SCHEDULE_FILTER_USER_ROUTE =
  process.env.REACT_APP_CALENDAR + "/api/v1/ScheduleFilterUser";

export const createScheduleFilterUser = (item: INewScheduleFilterUser) => {
  return GlobalAxios.post(SCHEDULE_FILTER_USER_ROUTE, item);
};

export const getScheduleFilterUserById = (id: string) => {
  return GlobalAxios.get<IScheduleFilterUser>(
    SCHEDULE_FILTER_USER_ROUTE + "/" + id
  );
};

export const updateScheduleFilterUserById = ({
  item,
  id,
}: {
  item: INewScheduleFilterUser;
  id: string;
}) => {
  return GlobalAxios.put(SCHEDULE_FILTER_USER_ROUTE + "/" + id, item);
};
